import state from './serviceState'
import mutations from './serviceMutations'
import actions from './serviceActions'
import getters from './serviceGetters'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
